const Section = ({ title, description, actions, children }) => (
  <div className="ac-collectif__section">
    <div className="ac-collectif__section-head">
      <div className="ac-collectif__section-heading">
        <h3 className="ac-collectif__section-title">{title}</h3>
        {description && (
          <p className="ac-collectif__section-description">{description}</p>
        )}
      </div>
      {actions && (
        <div className="ac-collectif__section-actions">{actions}</div>
      )}
    </div>
    <div className="ac-collectif__section-body">{children}</div>
  </div>
);

export default Section;
